'use strict';

import filtersModule from './ngmodule';

filtersModule.filter('unsafeHtml', ["$sce", function ($sce) {
  return $sce.trustAsHtml;
}]);